import { TableCell as MuiTableCell } from '@mui/material';
import { styled } from '@mui/system';
import colors from '../../../assets/colors';

const TableCell = styled(MuiTableCell, {
  shouldForwardProp: (prop) =>
    prop !== 'allSidesBordered' &&
    prop !== 'bottomRightBordered' &&
    prop !== 'employeeTable',
})(({ theme, allSidesBordered, bottomRightBordered, employeeTable }) => ({
  ...(allSidesBordered && {
    border: `2px solid ${colors.white}`,
  }),
  ...(bottomRightBordered && {
    borderRight: `2px solid ${colors.white}`,
    borderBottom: `2px solid ${colors.white}`,
  }),
  ...(employeeTable && {
    borderBottom: 'none',
  }),
  '&.MuiTableCell-head': {
    backgroundColor: colors.oldAgroweGreen,
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: 18,
  },
  '&.MuiTableCell-body': {
    fontSize: 17,
  },
}));

export default TableCell;
